<script setup lang="ts">
import { useBrowserStore } from '@apps/main/new-desktop/core/stores';

import { isFeatureToggleActive } from '@libs/feature-toggle';

import { useTripOverviewPageStore } from '../../stores';

import TripSummary from './TripSummary.vue';
import TripSummaryLoader from './TripSummaryLoader.vue';
import TripSummaryDesktopLoader from './TripSummaryDesktopLoader.vue';
import TripSummaryDesktop from './TripSummaryDesktop.vue';

const tripOverviewPageStore = useTripOverviewPageStore();
const browserStore = useBrowserStore();
</script>

<template>
  <div class="trip-summary-panel">
    <template
      v-if="
        tripOverviewPageStore.anyItineraryLoaded &&
        !isFeatureToggleActive('loader')
      "
    >
      <TripSummaryDesktop v-if="browserStore.isLargerThanMediumMax" />
      <TripSummary
        v-else
        :should-show-map="browserStore.isLargerThanExtraSmallMax"
        :is-main-summary="true"
      />
    </template>
    <TripSummaryDesktopLoader v-else-if="browserStore.isLargerThanMediumMax" />
    <TripSummaryLoader v-else />
  </div>
</template>

<style scoped lang="scss">
.trip-summary-panel {
  background-color: var(--color-white);
  padding: var(--spacing-24);
  height: 100vh;

  @include for-less-or-equal-than-extra-small-max {
    padding: var(--spacing-16);
  }

  @include for-less-or-equal-than-medium-max {
    height: auto;
    border-radius: var(--border-radius-12);
  }

  @include for-less-or-equal-than-medium-max {
    border: 1px solid var(--color-secondary-93);
  }
}
</style>
